// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4120adb8","239":"bdf506b6","455":"3ff4fc9f"}[chunkId] + ".chunk.js";
};